import { IconButtonProps as MatIconButtonProps } from "@mui/material"

import React, { FC } from "react"

import { ContactPerson } from "src/components/common/icon"
import { IconButton } from "src/components/common/iconButton"
import { create } from "src/helpers/bem"

import styles from "./ContactPersonButton.module.scss"

export type ContactPersonButtonProps = {} & MatIconButtonProps

const bem = create(styles, "ContactPersonButton")

export const ContactPersonButton: FC<ContactPersonButtonProps> = ({
  ...props
}) => (
  <div className={bem()}>
    <IconButton
      icon={ContactPerson}
      {...props}
      className={bem("ContactPerson")}
    />
  </div>
)
